export const SPACE_ID = 'space_id'
export const FOLDER_ID = 'folder_id'
export const LIST_ID = 'list_id'
